import React from "react";
import { Modal, Button, Timeline, Divider, Row, Col, Tooltip } from "antd";
import dayjs from "dayjs";
import { useProjectState } from "../../../context/stateContext";
import "./index.css";
import countOrdersImg from "../../../assets/images/orderCount.png";
import totalAmountImg from "../../../assets/images/totalAmount.png";
import tableNameImg from "../../../assets/images/table.png";
import calendarImg from "../../../assets/images/calendar.png";
import idImage from "../../../assets/images/id.png";

const MyMenuOrdersInfoModal = () => {
  const { openMyMenuOrdersInfoModal, setOpenMyMenuOrdersInfoModal } =
    useProjectState();

  return (
    <Modal
      className="mymenu-orders-info-modal"
      centered
      cancelButtonProps={{ style: { display: "none" } }}
      open={Object.entries(openMyMenuOrdersInfoModal).length > 0}
      bodyStyle={{ height: "auto" }}
      footer={null}
      onCancel={() => setOpenMyMenuOrdersInfoModal({})}
    >
      <Row>
        <Col className="mymenu-orders-info-modal-content-first-col" span={12}>
          <Tooltip placement="right" title="Име на маса">
            <img src={tableNameImg} alt="tableNameImg" width="20px" />
          </Tooltip>
          <b>{openMyMenuOrdersInfoModal.tableName}</b>
        </Col>

        <Col className="mymenu-orders-info-modal-content-second-col" span={12}>
          <Tooltip placement="right" title="Дата">
            <img src={calendarImg} alt="minutesImg" width="20px" />
          </Tooltip>
          <b>
            {dayjs(openMyMenuOrdersInfoModal.createdDate).format("DD.MM.YYYY")}{" "}
            г.
          </b>
        </Col>
      </Row>
      <Row>
        <Col className="mymenu-orders-info-modal-content-first-col" span={12}>
          <Tooltip placement="right" title="Брой поръчки">
            <img src={countOrdersImg} alt="countOrdersImg" width="20px" />
          </Tooltip>
          <b>{openMyMenuOrdersInfoModal.items?.length}</b>
        </Col>

        <Col className="mymenu-orders-info-modal-content-second-col" span={12}>
          <Tooltip placement="right" title="Обща сума">
            <img src={totalAmountImg} alt="totalAmountImg" width="20px" />
          </Tooltip>
          <b>{openMyMenuOrdersInfoModal.amount?.toFixed(2)} €</b>
        </Col>
      </Row>
      <Row>
        <Col span={12} className="mymenu-orders-info-modal-content-first-col">
          <Tooltip placement="right" title="ID на сметката">
            <img src={idImage} alt="waiterNameImg" width="20px" />
          </Tooltip>
          <b>{openMyMenuOrdersInfoModal.orderID}</b>
        </Col>
      </Row>

      <Divider className="mymenu-orders-info-modal-content-divider" />
      <div className="mymenu-orders-info-modal-content-timeline">
        <Timeline
          items={[
            {
              style: { padding: 0 },
              color: "green",
              children: (
                <>
                  <p>
                    <b>
                      {dayjs(openMyMenuOrdersInfoModal.createdDate).format(
                        "HH:mm:ss"
                      )}{" "}
                      Отваряне на сметка{" "}
                    </b>
                  </p>
                </>
              ),
            },
            ...(openMyMenuOrdersInfoModal["items"]?.map((item) => ({
              style: { padding: 0 },
              color: "gray",
              children: (
                <>
                  <p>
                    <b>
                      {dayjs(item.addedItemAt).format("HH:mm:ss")} Добавяне към
                      сметка
                    </b>
                  </p>

                  <p key={`bill-${item.touchSaleItemId}`}>
                    {parseFloat(item.quantity).toFixed(2)} x{" "}
                    {parseFloat(item.price).toFixed(2)}€ - {item.name}
                  </p>
                </>
              ),
            })) || []),
          ]}
        />
      </div>
      <div style={{ textAlign: "center" }}>
        <Button
          type="primary"
          onClick={() =>
            setOpenMyMenuOrdersInfoModal(!openMyMenuOrdersInfoModal)
          }
        >
          Затвори
        </Button>
      </div>
    </Modal>
  );
};

export default MyMenuOrdersInfoModal;
